export default {
	chat: "Bavarder",
	do_you_confirm_your_registration_for_the_webinar: "Confirmez-vous votre inscription au webinaire {title}?",
	do_you_confirm_your_unsubscription_to_the_webinar: "Confirmez-vous votre désinscription au webinaire {title}?",
	external_link: "Lien externe",
	join_webinar: "Rejoindre le webinaire",
	live: "Vivre",
	loading_webinars: "Chargement des webinaires",
	next: "Prochain",
	no_webinars_are_available_at_the_moment: "Il n'y a actuellement aucun webinaire disponible",
	no_webinars_are_available_with_the_selected_filter: "Aucun webinaire n'est disponible pour le filtre sélectionné",
	receive_emails_about_this_webinar: "Recevez des e-mails concernant ce webinaire",
	register_for_the_webinar: "Inscrivez-vous au webinaire",
	subscribe: "S'inscrire",
	subscribed: "Inscrit",
	successfully_signed_up_for_the_webinar: "Inscription au webinaire réussie",
	transmission_date: "Date de transmission",
	transmission_finished: "Transmission terminée",
	unsubscribe_from_the_webinar: "Se désinscrire du webinaire",
	unsubscribe_successfully_for_the_webinar: "Se désinscrire avec succès pour le webinaire",
	unsubscribe: "Se désabonner",
	watch: "Regarder",
	webinar_offline: "Webinaire hors ligne",
	write_your_question: "Écrivez votre question",
	your_message_has_been_received_and_is_awaiting_moderation: "Votre message a été reçu et attend la modération",
	your_message_has_been_received: "Votre message a été reçu",
	your_webinar_will_start_soon_please_wait: "Votre webinaire va bientôt commencer, veuillez patienter",
	cert_requirement: "Pour obtenir la certification du webinaire, un taux de présence de {min_watch_time_percentage}% lors de la première activité est requis.",
	fail_message: "Malheureusement, vous avez échoué ! Votre taux de présence à ce webinaire était de {webcast_user_session_percentage}%, alors qu'il fallait atteindre {min_watch_time_percentage}%.",
}